<template>
    <div>
        <h1 style="font-size: 24px; color: black;">用户管理</h1>
        <div style="margin-bottom: 10px;">
            <span>账号名称：</span>
            <el-input v-model="queryData.account" style="width: 200px" placeholder="请输入账号"></el-input>
            <span class="margin-left-10">账号状态：</span>
            <el-select v-model="queryData.state">
                <el-option v-for="_item in this.userStates" :key="_item.state" :value="_item.state"
                           :label="_item.val"></el-option>
            </el-select>
            <el-button type="primary" class="margin-left-10" @click="queryUsers">查询</el-button>
            <el-button type="primary" @click="showAddFormDialog(0, '新增用户')">添加用户</el-button>
        </div>
        <div>
            <el-dialog :title="dialogTitle" :visible.sync="addFormDialogVisible" center @close="closeAddFormDialog">
                <el-form :model="addForm">
                    <el-form-item label="账号" :label-width="labelWidth">
                        <el-input type="text" :disabled="dialogType==1" v-model="addForm.account"></el-input>
                    </el-form-item>
                    <el-alert class="elalert" type="error" :closable="false">
                        <template slot='title'>
                            <div class="iconSize">最少6位，包括至少1个大写字母，1个小写字母，1个数字，1个特殊字符(
                                _!@#$%^&*?,.)
                            </div>
                        </template>
                    </el-alert>

                    <el-form-item label="密码" :label-width="labelWidth">
                        <el-input type="password" v-model="addForm.password"></el-input>
                    </el-form-item>
                    <el-form-item label="密码确认" :label-width="labelWidth">
                        <el-input type="password" v-model="addForm.confirmPassword"></el-input>
                    </el-form-item>
                    <div style="text-align: center;">
                        <el-button type="primary" @click="confirmAddFormDialog">确 定</el-button>
                        <el-button type="info" @click="closeAddFormDialog">取 消</el-button>
                    </div>
                </el-form>
            </el-dialog>
        </div>
        <div>
            <el-table
                border
                :data="users">
                <el-table-column prop="uid" label="账号ID"></el-table-column>
                <el-table-column prop="account" label="账号"></el-table-column>
                <el-table-column  prop="roleId" label="角色" >
                    <template slot-scope="scope">
                        <div v-html="formatRole(scope.row.roleId)">

                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="账号状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.state===0">
                            正常
                        </span>
                        <span v-else>
                            已禁用
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="dtLastLogin" :formatter="formatDate" label="上次登录时间"></el-table-column>
                <el-table-column prop="dtCreate" :formatter="formatDate" label="注册时间"></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini"
                                   type="primary"
                                   @click="showRoleFormDialog( scope.row,'设置角色')">设置角色
                        </el-button>
                        <span v-if="scope.row.state===0">
                                <el-button size="mini"
                                           type="danger"
                                           @click="handleForbiddenDialog(scope.row)">
                                禁用
                                </el-button>
                            </span>
                        <span v-else>
                                 <el-button size="mini"
                                            type="success"
                                            @click="handleForbidden(scope.row)">
                                启用
                                </el-button>
                            </span>
                        <el-button size="mini"
                                   type="primary"
                                   @click="showAddFormDialog(1, '修改用户信息', scope.row)">修改密码
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div>
            <el-dialog :title="dialogTitle" :visible.sync="roleFormDialogVisible" center @close="closeRoleFormDialog">
                <el-form :model="roleForm">
                    <el-form-item label="角色选择:" :label-width="labelWidth">
                        <el-select multiple v-model="roleForm.roleId">
                            <el-option
                                v-for="item in roleList"
                                :label="item.name"
                                :value="item.id"
                                :key="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <div style="text-align: center;">
                        <el-button type="primary" @click="confirmRoleFormDialog">确 定</el-button>
                        <el-button type="info" @click="closeRoleFormDialog">取 消</el-button>
                    </div>
                </el-form>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import {allRoles, roleUpdate, searchUserList, updatePassword, userAdd, userForbidden} from "@/http/api";
import utils from '@/utils'

export default {
    inject: ['reload'],
    name: "UserList",
    data() {
        return {
            addForm: {
                account: '',
                password: '',
                confirmPassword: '',
            },
            userStates: [
                {state: -1, val: '全部'},
                {state: 0, val: '正常'},
                {state: 1, val: '禁用'}
            ],
            queryData: {
                account: '',
                state: 0
            },
            dialogTitle: '',
            dialogType: 0,
            labelWidth: '100px',
            addFormDialogVisible: false,
            users: [],
            roleForm: {
                uid: null,
                roleId: []
            },
            roleFormDialogVisible: false,
            roleList: []
        }
    },
    methods: {
        formatDate: function (row, column) {
            return utils.DateUtil.formatDate(row[column.property], "YYYY-MM-DD HH:mm:ss")
        },
        formatRole: function (ids) {
            let temp = "";
            ids.forEach(i =>
                this.roleList.forEach(item => {
                    if (item.id === i) {
                        temp += "<div>" + item.name + "</div>";
                    }
                })
            )
            return temp
        },
        handleForbiddenDialog(row) {
            this.$confirm('确定要禁用此账号吗?', '提示', {
                cancelButtonClass: 'btn-custom-cancel',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.handleForbidden(row)
            }).catch(() => {

            })
        },
        handleForbidden(row) {
            userForbidden(row.uid).then(resp => {
                if (resp.data.status === 0) {
                    row.state = row.state === 0 ? 1 : 0
                }
            }).catch(() => {
            })
        },
        showAddFormDialog(_type, _title, _data) {
            this.dialogType = _type
            this.dialogTitle = _title
            this.addForm = {
                account: '',
                password: '',
                confirmPassword: '',
            }
            if (_data) {
                this.addForm = _data
            }
            this.addFormDialogVisible = true
        },
        showRoleFormDialog(row, title) {
            this.roleForm.uid = row.uid;
            this.roleForm.roleId = row.roleId;
            this.dialogTitle = title;
            this.roleFormDialogVisible = true;
        },
        closeAddFormDialog() {
            this.addFormDialogVisible = false
        },
        closeRoleFormDialog() {
            this.roleFormDialogVisible = false
        },
        confirmAddFormDialog() {
            const param = /^.*(?=.{6,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[_!@#$%^&*?,.]).*$/
            let _message = ''
            if (this.addForm.account === '') {
                _message = '账号不能为空'
            } else if (this.addForm.password === '') {
                _message = '密码不能为空'
            } else if (!param.test(this.addForm.password)) {
                _message = '密码格式不正确'
            } else if (this.addForm.confirmPassword !== this.addForm.password) {
                _message = '密码不一致'
            }
            if (_message) {
                this.$message({
                    message: _message,
                    type: 'error'
                })
                return;
            }
            let func = null;
            if (this.dialogType === 0) {
                func = userAdd
            } else {
                func = updatePassword
            }
            func({
                account: this.addForm.account,
                password: this.addForm.password
            }).then(resp => {
                if (resp.data.status === 0) {
                    this.reload()
                    this.closeAddFormDialog()
                }
            }).catch(function () {
            })
        },
        confirmRoleFormDialog() {
            roleUpdate(this.roleForm.uid, this.roleForm.roleId).then(resp => {
                if (resp.data.status === 0) {
                    this.reload()
                    this.closeRoleFormDialog()
                }
            }).catch(function () {
            })
        },
        queryUsers() {
            searchUserList(this.queryData).then(resp => {
                this.users = resp.data.info;
            })
        }
    },
    created() {
        this.queryUsers()
        allRoles().then(resp => {
            this.roleList = resp.data.info;
        })
    }
}
</script>

<style scoped>

</style>
